import { Button, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../../../../constants/routes';

export const StationInUse = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Stack
      sx={{
        padding: { xs: '40px 22px 20px', maxWidth: '400px', gap: '20px' },
      }}
    >
      <Typography textAlign="center" variant="body1" color="common.white">
        {t('orderPage.station_in_use')}
      </Typography>
      <Button
        variant="contained"
        onClick={() => navigate(`/${ROUTES.CABINET}`)}
        sx={{ width: 'max-content' }}
      >
        {t('goToHomePage')}
      </Button>
    </Stack>
  );
};
